export default __webpack_public_path__ + "static/media/avatar.4e616743.png";